var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#1650FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20061_14834)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8333 23.5V17.6667L12.6667 13.5L8.5 17.6667V23.5H12.6667M16.8333 23.5H12.6667M16.8333 23.5H23.5V9.33333C23.5 9.11232 23.4122 8.90036 23.2559 8.74408C23.0996 8.5878 22.8877 8.5 22.6667 8.5H14.3333C14.1123 8.5 13.9004 8.5878 13.7441 8.74408C13.5878 8.90036 13.5 9.11232 13.5 9.33333V14.3333M12.6667 23.5V20.1667",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.833 11.8333V11.842",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.167 11.8333V11.842",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.167 15.1667V15.1755",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.167 18.5V18.5088",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20061_14834"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRent);
export default __webpack_public_path__ + "static/media/rent.c69c37083b0f43d26ebb983343ea5a8f.svg";
export { ForwardRef as ReactComponent };